import { ofType, Epic, combineEpics } from "redux-observable";
import { merge, of } from "rxjs";
import { catchError, map, mergeMap, takeUntil } from "rxjs/operators";
import { selectAuthTokens } from "../../../features/auth/selectors/auth.selector";
import { downloadStartAction } from "../../../features/download/redux/download.actions";
import { IAction } from "../../../interface/action.interface";
import { IErrorDto } from "../../../interface/dto/error.dto";
import { IRootState } from "../../../redux/root.reducer";
import { selectChangeLogFiltersAndPagination } from "../selectors/filters-and-pagination";
import { fetchChangeLogs } from "../service/change-log.api";
import {
    ChangeLogActionTypes,
    IChangeLogActions,
    changeLogLoadErrorAction,
    changeLogLoadSuccessAction,
    changeLogLoadAction,
} from "./change-log.actions";

const changeLogTableEpic: Epic<IAction, IAction, IRootState> = (
    action$,
    state$,
) =>
    merge(
        action$.pipe(
            ofType(ChangeLogActionTypes.CHANGE_LOG_INIT),
            map(changeLogLoadAction),
        ),
        action$.pipe(
            ofType<
                IChangeLogActions,
                ChangeLogActionTypes.CHANGE_LOG_LOAD_LISTS
            >(ChangeLogActionTypes.CHANGE_LOG_LOAD_LISTS),
            mergeMap(() =>
                fetchChangeLogs(
                    selectChangeLogFiltersAndPagination(state$.value),
                    selectAuthTokens(),
                ).pipe(
                    takeUntil(
                        action$.pipe(
                            ofType(ChangeLogActionTypes.CHANGE_LOG_LOAD_LISTS),
                        ),
                    ),
                    map((response) => changeLogLoadSuccessAction(response)),
                    catchError((error: IErrorDto) =>
                        of(changeLogLoadErrorAction(error.message)),
                    ),
                ),
            ),
        ),
        action$.pipe(
            ofType<
                IChangeLogActions,
                | ChangeLogActionTypes.CHANGE_LOG_SET_SEARCHQUERY
                | ChangeLogActionTypes.CHANGE_LOG_SET_PAGINATION
                | ChangeLogActionTypes.CHANGE_LOG_SET_SORTING
            >(
                ChangeLogActionTypes.CHANGE_LOG_SET_PAGINATION,
                ChangeLogActionTypes.CHANGE_LOG_SET_SORTING,
                ChangeLogActionTypes.CHANGE_LOG_SET_SEARCHQUERY,
            ),
            map(changeLogLoadAction),
        ),
        action$.pipe(
            ofType(ChangeLogActionTypes.CHANGE_LOG_EXPORT),
            mergeMap(() => [downloadStartAction("/change-logs/export")]),
        ),
    );

export const changeLogEpic = combineEpics(changeLogTableEpic);
